// extracted by mini-css-extract-plugin
export default {"form":"EventForm_form__O++62","title":"EventForm_title__xopWT","button":"EventForm_button__U8437"};